<!-- 设置 -->
<template>
	<div class="wrap">
		<div class="rightsidebar">

			<ul class="tab-list">
				<li v-for="(item,index) in tabList" :class="{active: tabId == item.id}" @click="tabId = item.id" :key="index">
					<a href="javascript:void(0)">{{item.title}}</a>
				</li>
			</ul>
			<!-- 个人资料 -->
			<div v-show="tabId == 0" class="personal-module">
				<p class="personal-module-label">我的信息</p>
				<div class="row">
					<label class="row-label">头像</label>
					<div class="upload-box">
						<img :src="userInfo.headimg" class="avatar">
						<!-- <img src="../../assets/avatar.png" class="avatar"> -->
					</div>
				</div>
				<div class="row">
					<label class="row-label">昵称</label>
					<div class="row-sidebar">
						<el-input v-model="userInfo.name" placeholder="请输入昵称"></el-input>
					</div>
				</div>
				<div class="row">
					<label class="row-label">性别</label>
					<div class="row-sidebar">
						<el-select v-model="userInfo.sex" placeholder="请选择性别">
							<el-option :label="'男'" :value="1"></el-option>
							<el-option :label="'女'" :value="2"></el-option>
						</el-select>
					</div>
				</div>
				<div class="row">
					<label class="row-label">生日</label>
					<div class="row-sidebar">
						<el-date-picker v-model="userInfo.birthday" type="date" placeholder="请选择生日"></el-date-picker>
					</div>
				</div>
				<div class="row">
					<label class="row-label">居 住 地</label>
					<div class="row-sidebar">
						<el-input :value="`${userInfo.province_name}-${userInfo.city_name}-${userInfo.counties_name}`" disabled placeholder="请输入居住城市"></el-input>
					</div>
				</div>
				<div class="row">
					<label class="row-label">邀 请 码</label>
					<div class="row-sidebar">
						<el-input v-model="userInfo.invite_code" disabled placeholder="请输入邀请码"></el-input>
					</div>
				</div>
				<div class="btn-box">
					<button type="button" @click="updateUserInfo()">保存</button>
				</div>
			</div>
			<!-- 收货地址 -->
			<div v-show="tabId == 1" class="address-module">
				<div class="address-top">
					<div class="row-between">
						<div class="row-between-leftsidebar">
							<span class="font-1">收货地址</span>
						</div>
						<span class="manage-all-addresses" @click="myAddress">管理全部地址</span>
					</div>
					<ul class="select-address-list">
						<li :class="{active: item.is_mr == 1}" v-for="(item, index) in addressList" :key="index">
							<div class="select-address-sidebar" @click="changeApproveDelivery(item.id)">
								<p class="people-name">{{item.name}}</p>
								<p class="addrss-box">
									<span class="addrss-msg">
										{{item.pro_name}}
										{{item.city_name}}
										{{item.county_name}}
										{{item.street_name}}
										{{item.detail}}
									</span>
									<span class="people-phone-num">{{item.phone}}</span>
								</p>
							</div>
							<div class="select-address-btn-box">
								<button type="button" @click="delAddress(item.id)">删除</button>
								<button type="button" @click="currentEditId = item.id; dialogFormVisible = true">修改</button>
							</div>
						</li>
						<!-- 无内容时显示 -->
						<div class="normal-box" v-if="addressList.length == 0">
							<img src="../../assets/normal-3.png">
							暂无收货地址
						</div>
					</ul>
				</div>
				<!-- <div class="address-bottom">
					<div class="row-between">
						<div class="row-between-leftsidebar">
							<span class="font-1">新增收货地址</span>
						</div>
					</div>
					<div class="row-start">
						<label class="row-start-label"><span class="red-color">*</span>收货人</label>
						<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
							<div style="min-width: 234px;display: flex;align-items: center;">
								<el-input v-model="addressParams.name" placeholder="收货人姓名"></el-input>
							</div>
						</div>
					</div>
					<div class="row-start">
						<label class="row-start-label"><span class="red-color">*</span>手机号</label>
						<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
							<div style="min-width: 234px;display: flex;align-items: center;">
								<el-input v-model="addressParams.phone" placeholder="手机号"></el-input>
							</div>
						</div>
					</div>
					<div class="row-start">
						<span class="row-start-label"><span class="red-color">*</span>省市区域</span>
						<div class="row-sidebar" style="flex-direction: column;align-items: flex-start;">
							<div style="width: 700px;display: flex;align-items: center;justify-content: space-between;">
								<div class="select-item">
									<el-select v-model="addressPickerValue[0]" @change="bindColumnchange(0, $event)"
										placeholder="请选择省份">
										<el-option v-for="(item, index) in addressPickerData[0]" :key="index"
											:label="item.name" :value="index">
										</el-option>
									</el-select>
								</div>
								<div class="select-item">
									<el-select v-model="addressPickerValue[1]" @change="bindColumnchange(1, $event)"
										placeholder="请选择城市">
										<el-option v-for="(item, index) in addressPickerData[1]" :key="index"
											:label="item.name" :value="index">
										</el-option>
									</el-select>
								</div>
								<div class="select-item">
									<el-select v-model="addressPickerValue[2]" @change="bindColumnchange(2, $event)"
										placeholder="请选择区/县">
										<el-option v-for="(item, index) in addressPickerData[2]" :key="index"
											:label="item.name" :value="index">
										</el-option>
									</el-select>
								</div>
								<div class="select-item">
									<el-select v-model="addressPickerValue[3]" @change="bindColumnchange(3, $event)"
										placeholder="请选择街道">
										<el-option v-for="(item, index) in addressPickerData[3]" :key="index"
											:label="item.name" :value="index">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="row-start">
						<div class="flex-end-box">
							<div style="width: 700px;display: flex;align-items: center;justify-content: space-between;">
								<el-input type="textarea" placeholder="请填写详细地址~" class="textarea"
									v-model="addressParams.detail">
								</el-input>
							</div>
						</div>
					</div>
					<div class="row-start">
						<div class="flex-end-box">
							<div style="width: 548px;display: flex;align-items: center;justify-content: space-between;">
								<label for="c12" class="form-bottom">
									<input id="c12" name="pass" type="checkbox" checked ref="is_mr"
										@change="addressParams.is_mr = ($refs['is_mr'].checked ? 1 : 0)" />
									<span>设为默认地址</span>
								</label>
							</div>
						</div>
					</div>
					<div class="row-start">
						<div class="flex-end-box">
							<div style="width: 548px;display: flex;align-items: center;justify-content: space-between;">
								<div class="form-btn-box">
									<button type="button" class="active" @click="setDeliveryAddress()">保存</button>
									<button type="button" class="active" @click="initAddress()">取消</button>
								</div>
							</div>
						</div>
					</div>
				</div> -->
			</div>

			<!-- 隐私政策： -->
			<div v-show="tabId == 2" class="privacy-policy-module">
				<p>隐私政策11111111</p>
				<div class="logout-btn-box center">
					<button type="button">已阅读</button>
				</div>
			</div>
			<!-- 客服电话： -->
			<div v-show="tabId == 3" class="customer-service-module">
				<div class="customer-service-box">
					<span class="customer-service-label">客服电话：</span>
					<p class="customer-service-row">
						<span>4005665205</span>
						<span>4005665205</span>
					</p>
				</div>
				<img src="../../assets/icon-28.png" class="customer-service-img1">
				<img src="../../assets/icon-29.png" class="customer-service-img2">
			</div>
			<!-- 注销用户 -->
			<div v-show="tabId == 4" class="logout-module">
				<p class="logout-label">注销账号存在以下风险</p>
				<ul class="logout-list">
					<li>您账号下的各项信息将被清空且无法恢复</li>
					<li>您的历史合同、订单、交易记录将无法查看</li>
					<li>您获得的折扣、特权、卡券等权益将视为自动放弃</li>
					<li>将解除与其它网站、其他APP的授权或绑定关系</li>
				</ul>
				<label for="c1" class="logout-bottom">
					<input id="c1" name="pass" type="checkbox" checked ref="CancelUserInfo" />
					<span style="flex: 1;">申请提交即表示您自愿放弃账户内所有虚拟财产并同意<span class="red-color"
							@click="cancellationNotice">《注销须知》</span></span>
				</label>
				<div class="logout-btn-box">
					<button type="button" @click="cancelUserInfo()">申请注销用户</button>
				</div>
			</div>
			<!-- 关于我们： -->
			<div v-show="tabId == 5" class="privacy-policy-module">
				<p>关于我们11111111</p> 
			</div>
		</div>
		<!-- 新增/修改 地址弹窗-->
		<AddressAdd v-model="dialogFormVisible" :add_id="currentEditId" @save="addressAddSave"></AddressAdd>


	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Footer from '../../components/footer.vue';
	import {
		areaGetAreaChildrenByID,
		userManageGetDeliveryAddressDetail,
		userManageSetDeliveryAddress,
		userManageChangeApproveDelivery,
		userManageDelDeliveryAddress,
		userManageGetDeliveryAddressList,
		userCenterCancelUserInfo,
    userCenterGetUserInfo,
    userCenterUpdateUserInfo,
	} from '../../service/service';
	import {
		validatorFun
	} from '../../utils/util';
	import AddressAdd from '../../components/address-add.vue';

	export default {
		components: {
			Header,
			Footer,
			AddressAdd
		},
		data() {
			return {
				//选项卡
				tabId: 0,
				tabList: [{
					id: 0,
					title: "个人资料"
				}, {
					id: 1,
					title: "收货地址"
				}, {
					id: 2,
					title: "隐私政策"
				// }, {
				// 	id: 3,
				// 	title: "客服电话"
				}, {
					id: 4,
					title: "注销用户"
				}, {
					id: 5,
					title: "关于我们"
				}],
				name: '', //昵称
				options: [{
					value: '选项1',
					label: '男'
				}, {
					value: '选项2',
					label: '女'
				}],
				value: '', //性别
				value1: '', //生日
				city: '', //居住地
				code: '', //邀请码

				region: '',
				region2: '',
				region3: '',
				desc: '',


				addressList: [],
				addressParams: {
					id: 0, // 收货地址记录id（不传值是添加）
					pro_name: '', // 省名
					city_name: '', // 市名
					county_name: '', // 县区名
					street_name: '', // 街道
					detail: '', // 详细地址
					phone: '', // 联系电话
					name: '', // 联系人
					is_mr: 0, // 是否是默认（0不默认，1默认）
				},

				// 地址
				addressPickerData: [
					[],
					[],
					[],
					[]
				],
				addressPickerDataNames: [
					[],
					[],
					[],
					[]
				],
				addressPickerValue: [0, 0, 0, 0],
				addressPickerValueStr: '',

				dialogFormVisible: false, //弹窗
				currentEditId: 0,
				form: {
					username: '',
					phone_number: '',
					region: '',
					region2: '',
					region3: '',
					desc: '',
				},
				// 用户信息
				userInfo: {},
			};
		},
		mounted() {
			const option = this.$route.query;
			this.tabId = parseInt(option.tabId || 0);
			this.getAddressList();
			this.initAddress();
			this.getUserInfo();
		},
		methods: {
			
			updateUserInfo() {
				const params = this.userInfo;
				// const errMsg = {
				// 	name: '请输入昵称',
				// 	headimg: '请选择头像',
				// 	sex: '请选择性别', // 性别（1男2女）
				// 	birthday: '请选择生日',
				// 	address: '请选择地址', // 地址（山东省-临沂市-兰山区）
				// };
				const errList = validatorFun(params, [
					['name', ['notNull', '请输入昵称']],
					['headimg', ['notNull', '请选择头像']],
					['sex', ['notNull', '请选择性别']],
					['birthday', ['notNull', '请选择生日']],
					// ['address', ['notNull', '请选择地址']],
				]);
				if (errList.length > 0) {
					return this.$message.warning(errList[0].errMsg);
				}
				userCenterUpdateUserInfo(this.userInfo).then(({code, msg, data}) => {
					if (code == 1) {
						this.$message.success(msg);
						this.getUserInfo();
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取用户信息
			getUserInfo() {
				userCenterGetUserInfo().then(({code, data, msg}) => {
					if (code == 1) {
						this.userInfo = data.detail;
					} else {
						this.$message.error(msg);
					}
				});
			},
			initAddress() {
				this.addressParams = {
					id: 0, // 收货地址记录id（不传值是添加）
					pro_name: '', // 省名
					city_name: '', // 市名
					county_name: '', // 县区名
					street_name: '', // 街道
					detail: '', // 详细地址
					phone: '', // 联系电话
					name: '', // 联系人
					is_mr: 0, // 是否是默认（0不默认，1默认）
				};
				// 地址
				this.addressPickerData = [
					[],
					[],
					[],
					[]
				];
				this.addressPickerDataNames = [
					[],
					[],
					[],
					[]
				];
				this.addressPickerValue = [0, 0, 0, 0];
				this.addressPickerValueStr = '';
				this.getAreaChildrenByID();
			},
			addressAddSave(success) {
				if (success) {
					this.getAddressList();
				}
			},
			// 获取列表
			getAddressList() {
				userManageGetDeliveryAddressList({
					page: 1,
					page_num: 10,
				}).then(res => {
					if (res.code === 1) {
						const list = res.data.list.map(item => {
							const [first_name, ...last_name] = item.name.split('');
							item['first_name'] = first_name;
							item['last_name'] = last_name.join('');
							return item;
						});
						this.addressList = list;
						// this.addressList = page > 1 ? [...this.list, ...list] : list;
						// if (list.length === 0) {
						// 	this.$message.warning(msg);
						// } else {
						// 	this.page = this.page + 1;
						// }
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 新增地址
			setDeliveryAddress() {
				const params = this.addressParams;
				console.log(params);
				const errList = validatorFun(params, [
					['name', ['notNull', '请输入收货人']],
					['phone', ['notNull', '请输入手机号码'],
						['isMobile', '请输入正确手机号']
					],
					['pro_name', ['notNull', '请输入选择所在地区']],
					['city_name', ['notNull', '请输入选择所在地区']],
					['county_name', ['notNull', '请输入选择所在地区']],
					['street_name', ['notNull', '请输入选择所在地区']],
					['detail', ['notNull', '请输入详细地址']],
				]);
				if (errList.length > 0) {
					return this.$message.error(errList[0].errMsg);
				}
				userManageSetDeliveryAddress(params).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						this.getAddressList();
						this.initAddress();
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}

				});
			},
			// 获取地址详情
			getAddressDetail() {
				userManageGetDeliveryAddressDetail({
					id: this.addressParams.id
				}).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						const {
							id,
							pro_id,
							city_id,
							county_id,
							pro_name,
							city_name,
							county_name,
							street_name,
							detail,
							phone,
							name,
							is_mr,
						} = data;
						this.addressParams = {
							id,
							pro_name,
							city_name,
							county_name,
							street_name,
							detail,
							phone,
							name,
							is_mr,
						};
						const arr = [
							pro_name,
							city_name,
							county_name,
							street_name,
						];
						this.select = is_mr == 1;
						this.addressPickerValueStr = arr.join(' ');
						const fn = (id2 = 0, idx2, level = 1) => {
							const name = arr.splice(0, 1)[0];
							this.getAreaChildrenByID(id2, idx2, level, level, () => {
								const idx = this.addressPickerDataNames[level - 1].indexOf(name);
								if (arr.length > 0) {
									let id3 = this.addressPickerData[level - 1][idx].id;
									fn(id3, idx, level + 1);
								} else {
									this.getAreaChildrenByID(0, idx, level + 1, level);
								}
							});
						}
						fn();
					} else {
						this.$message.error(msg);
					}
				});
			},
			getAreaChildrenByID(id = 0, idx = 0, level = 1, maxLevel = 4, callback) {
				const list = [...this.addressPickerData];
				const listIds = [...this.addressPickerDataNames];
				const vals = [...this.addressPickerValue];
				vals[level - 2] = idx;
				const fn = (id = 0, level2 = 1) => {
					if (level2 > maxLevel) {
						this.addressPickerData = list;
						this.addressPickerDataNames = listIds;
						this.addressPickerValue = vals;
						this.bindPickerChange();
						callback && callback();
						return;
					}
					areaGetAreaChildrenByID({
						id
					}).then(({
						code,
						msg,
						data
					}) => {
						if (code == 1) {
							list[level2 - 1] = data.list;
							listIds[level2 - 1] = data.list.map(item => item.name);
							vals[level2 - 1] = 0;
							fn(data.list[0].id, level2 + 1);
						} else {
							this.$message.error(msg);
						}
					});
				};
				fn(id, level);
			},


			// 设置默认地址
			changeApproveDelivery(id) {
				this.$confirm('确认设为默认地址?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userManageChangeApproveDelivery({
						id
					}).then(({
						code,
						msg,
						data
					}) => {
						if (code == 1) {
							this.getAddressList();
							this.$message.success(msg);
						} else {
							this.$message.error(msg);
						}
					});
				});
			},
			// 删除地址
			delAddress(id) {
				this.$confirm('确认删除地址?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userManageDelDeliveryAddress({
						id
					}).then(({
						code,
						msg,
						data
					}) => {
						if (code == 1) {
							this.getAddressList();
							this.$message.success(msg);
						} else {
							this.$message.error(msg);
						}
					});
				});
			},
			bindPickerChange() {
				const [pIdx, cIdx, aIdx, sIdx] = this.addressPickerValue;
				const [province, city, area, street] = this.addressPickerData;
				this.addressPickerValueStr =
					`${province[pIdx].name} ${city[cIdx].name} ${area[aIdx].name} ${street[sIdx].name}`;
				this.addressParams.pro_name = province[pIdx].name;
				this.addressParams.city_name = city[cIdx].name;
				this.addressParams.county_name = area[aIdx].name;
				this.addressParams.street_name = street[sIdx].name;
				console.log(this.addressParams);
			},
			bindColumnchange(column, value) {
				this.getAreaChildrenByID(this.addressPickerData[column][value].id, value, column + 2);
			},
			//选项卡
			active(index) {
				this.active = index
			},

			// 注销账户
			cancelUserInfo() {
				if (!this.$refs['CancelUserInfo'].checked) {
					return this.$message.warning('请阅读并同意《注销须知》');
				}

				this.$confirm('确定注销账户吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					userCenterCancelUserInfo().then(({
						code,
						msg
					}) => {
						if (code == 1) {
							this.$message.success(msg);
						} else {
							this.$message.error(msg);
						}
					});
				});
			},

			//跳转注销须知
			cancellationNotice() {
				this.$router.push('/my/cancellation-notice')
			},

			//跳转收货地址页面
			myAddress() {
				this.$router.push('/my/my-address')
			},

		}
	}
</script>

<style scoped>
	input::placeholder,
	textarea::placeholder {
		color: #BBBBBB;
	}

	.wrap {
		width: 100%;
		margin: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 0px);
		display: flex;
		flex-direction: column;
	}


	.tab-list {
		width: 100%;
		height: 70px;
		overflow: auto;
		white-space: nowrap;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-bottom: 15px;
	}

	.tab-list>li {
		display: inline-block;
		width: 200px;
		height: 70px;
	}

	.tab-list>li>a {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #111111;
		font-size: 18px;
	}

	.tab-list>li.active>a {
		background-color: #F2501A;
		color: #FFFFFF;
		border-radius: 5px;
	}

	.personal-module {
		width: 100%;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 67px 0 0;
		display: flex;
		flex-direction: column;
		margin-bottom: 15px;
	}

	.personal-module-label {
		width: 100%;
		color: #111111;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 6px;
		padding-left: 60px;
		box-sizing: border-box;
	}

	.row {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.row-label {
		width: 117px;
		color: #111111;
		font-size: 16px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-right: 55px;
	}

	.upload-box {
		display: flex;
		align-items: center;
	}

	.avatar {
		width: 130px;
		height: 130px;
		object-fit: cover;
		border-radius: 50%;
	}

	.row-sidebar {
		width: 205px;
		display: flex;
		align-items: center;
	}

	.wrap >>>.el-input__inner {
		height: 40px !important;
		line-height: 40px !important;
		/* border: 1px solid #BBBBBB !important; */
		color: #111111;
		font-size: 16px !important;
	}

 	.wrap >>>.el-input__icon {
		line-height: 30px !important;
	}

	.btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 30px 60px 55px;
		box-sizing: border-box;
	}

	.btn-box>button,
	.form-btn-box>button {
		width: 214px;
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 16px;
		background-color: #F2501A;
		border-radius: 8px;
	}

	.logout-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 22px 30px 40px;
		box-sizing: border-box;
		margin-bottom: 15px;
	}

	.logout-label {
		width: 100%;
		color: #090909;
		font-size: 16px;
		margin-bottom: 10px;
	}

	.logout-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.logout-list>li {
		width: 100%;
		color: #919191;
		font-size: 14px;
		margin-bottom: 10px;
		padding-left: 18px;
		box-sizing: border-box;
		position: relative;
	}

	.logout-list>li::after {
		content: "";
		position: absolute;
		left: 4px;
		top: 50%;
		transform: translate(0, -50%);
		border-radius: 50%;
		width: 6px;
		height: 6px;
		background-color: #F2501A;
	}

	.logout-list>li:last-child {
		margin-bottom: 0;
	}

	.logout-btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 24px;
	}

	.logout-btn-box>button {
		width: 214px;
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 16px;
		background-color: #F2501A;
		border-radius: 8px;
	}

	.logout-bottom {
		width: 100%;
		display: flex;
		align-items: flex-start;
		color: #000000;
		font-size: 16px;
		margin-top: 20px;
	}

	.red-color {
		color: #F2501A;
	}

	input[type="checkbox"] {
		width: 15px !important;
		height: 15px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/square.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 12px;
		margin-top: 3.5px;
	}

	input[type="checkbox"]:checked {
		background: url(../../assets/square-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.customer-service-module {
		width: 100%;
		height: 581px;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 44px 64px;
		box-sizing: border-box;
		position: relative;
	}

	.customer-service-img1 {
		width: 438px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 0;
	}

	.customer-service-img2 {
		width: 178px;
		position: absolute;
		right: 143px;
		bottom: 0;
		z-index: 0;
	}

	.customer-service-box {
		width: 100%;
		z-index: 99;
		display: flex;
		align-items: flex-start;
		position: relative;
	}

	.customer-service-label {
		line-height: 31px;
		color: #111111;
		font-size: 25px;
		margin-right: 40px;
	}

	.customer-service-row {
		line-height: 31px;
		display: flex;
		flex-direction: column;
		color: #111111;
		font-size: 25px;
	}

	.customer-service-row>span {
		margin-bottom: 10px;
	}

	.customer-service-row>span:last-child {
		margin-bottom: 0;
	}

	.address-module {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.address-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 10px;
	}

	.row-between {
		width: 100%;
		height: 69px;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.row-between-leftsidebar {
		display: flex;
		align-items: center;
	}

	.font-1 {
		color: #111111;
		font-size: 20px;
		font-weight: bold;
	}

	.add-address-btn {
		width: 122px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		border-radius: 5px;
		color: #111111;
		font-size: 16px;
		margin-left: 30px;
	}

	.add-address-btn>span {
		color: #F2501A;
		margin-right: 7px;
	}

	.manage-all-addresses {
		color: #111111;
		font-size: 16px;
	}

	.select-address-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;
	}

	.select-address-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.select-address-list>li:last-child {
		margin-bottom: 0;
	}

	.select-address-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.people-name {
		min-width: 93px;
		padding: 0 10px;
		box-sizing: border-box;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #484848;
		font-size: 16px;
		position: relative;
		border-radius: 5px;
		overflow: hidden;
	}

	.addrss-box {
		flex: 1;
		display: flex;
		align-items: center;
		margin-left: 16px;
	}

	.addrss-msg {
		color: #484848;
		font-size: 16px;
	}

	.people-phone-num {
		color: #484848;
		font-size: 16px;
		margin-left: 20px;
	}

	.select-address-btn-box {
		display: flex;
		align-items: center;
	}

	.select-address-btn-box>button {
		font-size: 16px;
		color: #777777;
		margin-right: 20px;
	}

	.select-address-btn-box>button:last-child {
		margin-right: 0;
		color: #F2501A;
	}

	.select-address-list>li.active .people-name {
		border: 1px solid #E63D23;
	}

	.select-address-list>li.active .people-name::after {
		content: "";
		width: 25px;
		height: 25px;
		background: url(../../assets/icon-24.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.select-address-list>li.active .addrss-msg {
		color: #F2501A;
	}

	.select-address-list>li.active .people-phone-num {
		color: #F2501A;
	}

	.row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.row-start-label {
		width: 126px;
		line-height: 30px;
		color: #000000;
		font-size: 16px;
	}

	.row-start-label>span {
		margin-right: 7px;
	}

	.address-bottom {
		width: 100%;
		border-radius: 8px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
	}

	.wrap >>>.el-input__icon {
		line-height: 30px !important;
	}

	.wrap >>>.el-textarea__inner {
		height: 199px !important;
		border: 1px solid #BBBBBB !important;
		color: #111111;
		font-size: 16px;
	}

	.select-item {
		width: 171px;
	}

	.flex-end-box {
		margin-left: 126px;
	}

	.form-bottom {
		display: flex;
		align-items: center;
		color: #000000;
		font-size: 18px;
	}

	input[type="checkbox"] {
		width: 15px !important;
		height: 15px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/square.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 5px;
		margin-top: 3.5px;
	}

	input[type="checkbox"]:checked {
		background: url(../../assets/square-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.form-btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding-bottom: 20px;
	}

	.form-btn-box>button {
		font-size: 17px;
		margin-right: 18px;
	}

	.form-btn-box>button:last-child {
		border: 1px solid #E63D23;
		background-color: #FFFFFF;
		color: #F2501A;
	}

	.privacy-policy-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 23px 30px;
		box-sizing: border-box;
		font-size: 14px;
		color: #111111;
	}

	.logout-btn-box.center {
		justify-content: center;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.normal-box>img {
		width: 280px;
		margin-bottom: 7px;
	}

	.wrap >>>.el-dialog__header {
		padding: 15px 17px 15px !important;
		background-color: #F9F9F9 !important;
	}

	.el-dialog__headerbtn>>>.el-dialog__close {
		color: #777777 !important;
	}

	.wrap >>>.el-dialog {
		width: 812px !important;
		position: fixed !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;
		border-radius: 8px !important;
		overflow: hidden !important;
	}

	.wrap >>>.el-dialog__body {
		padding: 36px 0 41px !important;
	}

	.form-row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 15px;
	}

	.form-row-start-label {
		width: 141px;
		text-align: right;
		line-height: 40px;
		color: #111111;
		font-size: 18px;
		padding-right: 16px;
		box-sizing: border-box;
	}

	.form-row-start-label>span {
		margin-right: 6px;
	}

	.form-row-sidebar {
		width: 205px;
		display: flex;
		align-items: center;
	}

	.select-item-2 {
		width: 174px;
	}

	.form-flex-end-box {
		margin-left: 141px;
	}

	.form-bottom-2 {
		display: flex;
		align-items: center;
		color: #777777;
		font-size: 15px;
	}

	.form-bottom-2 input[type="checkbox"] {
		width: 14px !important;
		height: 14px !important;
		vertical-align: middle;
		-webkit-appearance: none;
		background: url(../../assets/circle.png) no-repeat center center;
		background-size: 100% 100%;
		margin-right: 13px;
		margin-top: 1.5px;
	}

	.form-bottom-2 input[type="checkbox"]:checked {
		background: url(../../assets/circle-active.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.form-btnBox-2 {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.form-btnBox-2>button {
		width: 104px;
		height: 34px;
		line-height: 34px;
		background-color: #F2501A;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		color: #FFFFFF;
		margin-right: 14px;
	}

	.form-btnBox-2>button:last-child {
		border: 1px solid #DCDCDC;
		background-color: #FFFFFF;
		color: #777777;
	}
</style>
